module.exports = __webpack_public_path__ + "img/reka.53fd4e53.png";